export default {
  default: {
    title: 'Could not Generate PDF Preview',
    paragraph: 'An error has occured causing the PDF not to generate. Please refresh your browser, if the issue persists please contact support.',
  },
}
